import React from 'react';
import { Link } from 'react-router-dom';

import BlackBoardVtaAnalytics1 from '../../assets/BlackBoardVtaAnalytics1.png';
import BlackBoardVtaAnalytics2 from '../../assets/BlackBoardVtaAnalytics2.png';
import BlackBoardVtaAnalytics3 from '../../assets/BlackBoardVtaAnalytics3.png';
const VtaAnalyticsPage = () => {

  return (
    <div className="min-h-screen bg-purple-50">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Tutor Analytics
          </h1>
          <div className="text-lg text-gray-700 mb-8 max-w-3xl mx-auto leading-relaxed">
            <p className="mb-4">
              Comprehensive insights into your AI Virtual Tutor's performance and student interactions.
            </p>
            <p className="text-xl font-semibold text-purple-700 mb-6">
              Monitor key metrics, track student engagement, and optimize learning outcomes
            </p>

            {/* Feature Descriptions */}
            <div className="grid md:grid-cols-3 gap-6 mt-8 text-left">
              <div className="bg-white p-6 rounded-lg shadow-md border border-purple-100">
                <h3 className="text-lg font-semibold text-purple-700 mb-3">
                  Track Usage & Engagement
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  See how often students are using CampusMind, what kinds of questions they're asking, and when they're most active. The dashboard gives you quick, meaningful insights, without any digging.
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-md border border-purple-100">
                <h3 className="text-lg font-semibold text-purple-700 mb-3">
                  Spot Learning Gaps
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  The "Most Asked Topics" section helps you identify concepts students are struggling with or topics that might need more attention in class.
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-md border border-purple-100">
                <h3 className="text-lg font-semibold text-purple-700 mb-3">
                  Monitor Trends Over Time
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  View weekly breakdowns of active users to understand usage patterns across the semester. This helps you adapt your teaching strategy to meet students where they are.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center mb-12">
          <img
            src={BlackBoardVtaAnalytics1}
            alt="CampusMind in Blackboard"
            className="w-full max-w-4xl rounded-2xl shadow-lg"
          />
        </div>
        <div className="flex justify-center mb-12">
          <img
            src={BlackBoardVtaAnalytics2}
            alt="CampusMind in Blackboard"
            className="w-full max-w-4xl rounded-2xl shadow-lg"
          />
        </div>
        <div className="flex justify-center mb-12">
          <img
            src={BlackBoardVtaAnalytics3}
            alt="CampusMind in Blackboard"
            className="w-full max-w-4xl rounded-2xl shadow-lg"
          />
        </div>

        {/* Action Buttons */}
        <div className="text-center mt-12">
          <div className="text-lg text-purple-700 font-bold mb-4">
            <strong>Ready to take action?</strong><br />
            Manage your Tutor, test performance, or return to the main dashboard.
          </div>

          <div className="flex justify-center gap-4 md:gap-8 flex-wrap">
            <Link
              to="/manage-vta"
              className="bg-purple-700 text-white px-6 py-3 rounded-lg font-medium hover:bg-purple-800 transition-colors duration-200"
            >
              Manage Tutor
            </Link>
            <Link
              to="/test"
              className="bg-gray-700 text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-800 transition-colors duration-200"
            >
              Test Tutor
            </Link>
            <Link
              to="/"
              className="bg-gray-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-700 transition-colors duration-200"
            >
              Back: Start
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VtaAnalyticsPage; 
